import { radioAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, defineStyle } from "@chakra-ui/react";
import Colors from "../../assets/colors/Colors";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(radioAnatomy.keys);

const baseStyle = definePartsStyle({
  control: {
    border: "2px solid",
    borderColor: "#010048",
    _checked: {
      bg: "white",
      borderColor: "#5881FE",
      color: "#5881FE",

      _before: {
        content: '""',
        display: "block",
        w: "0.5rem",
        h: "0.5rem",
        bg: "#5881FE",
        borderRadius: "50%",
      },

      _hover: {
        bg: "white",
        borderColor: "#5881FE",
      },
    },
  },
});

const xl = defineStyle({
  w: "1.25rem",
  h: "1.25rem",
});

const sizes = {
  xl: definePartsStyle({ control: xl }),
};

// Export the component theme
export const radioTheme = defineMultiStyleConfig({ baseStyle, sizes });
